import { includes } from "lodash-es";
import type { Incoterm } from "../sharedTypes";

export const isFShipment = (incoterm: Incoterm | null): boolean =>
  includes(["fob", "fca", "fas"], incoterm);
